import axiosInstance from "./axiosInstance";
import { ResponseType } from "axios";   

type RequestMethod = "GET" | "POST" | "PUT" | "DELETE";

interface ApiOptions {
  method?: RequestMethod;
  body?: Record<string, any>;
  headers?: Record<string, string>;
  params?: Record<string, string | number>;
  responseType?: ResponseType;        
}

const api = async <T>(endpoint: string, options: ApiOptions = {}): Promise<T> => {
  const {
    method = "GET",
    body,
    headers,
    params,
    responseType,                
  } = options;

  try {
    const response = await axiosInstance.request<T>({
      url: endpoint,
      method,
      data: body,
      headers,
      params,
      responseType,                
    });
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export default api;